export default {
  data: () => ({
    componentKey: 0
  }),

  methods: {
    resetInputs() {
      this.forceRerender()
    },

    forceRerender() {
      this.componentKey = this.componentKey === 0 ? 1 : 0
    }
  }
}
